import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import Form from "ui/elements/form/Form";

/**
 * Layer Sharpness Factor Picker
 */
export default class SharpnessSetup extends Dialog {
	constructor() {
		super({
			title: i18n('title.sharpness-setup'),
			smallWidth: true,
			buttons: [
				{
					caption: i18n('buttons.apply'),
					role: 'apply',
					icon: '/images/icons.svg#icon-svg-check'
				},
				{
					caption: i18n('buttons.close'),
					role: 'close'
				}
			]
		});

		/**
		 * @type {Form}
		 * @private
		 */
		this._form = null;

		/**
		 * @type {?function(res: number|null)}
		 * @private
		 */
		this._onComplete = null;

		void this._buildForm();
	}

	/**
	 * @returns {Promise<number|null>}
	 */
	getResultPromise() {
		return new Promise((resolve) => {
			this._onComplete = resolve;
		});
	}

	/**
	 * @override
	 * @param {string} role
	 * @returns {void}
	 * @protected
	 */
	_handleButton(role) {
		super._handleButton(role);
		if (role === 'apply') {
			let data = this._form.getValues();
			if (data !== null) {
				this._apply(data);
			}
		}
	}

	/**
	 * @private
	 * @param {Object} data
	 * @returns {void}
	 */
	_apply(data) {
		if (this._onComplete) {
			this._onComplete(parseFloat(data.factor) / 100);
			this._onComplete = null;
			this.destroy();
		}
	}

	/**
	 * @private
	 * @returns {Promise<void>}
	 */
	async _buildForm() {
		let el = document.createElement('div');
		this._form = new Form({
			parent: el,
			onApply: this._apply.bind(this),
			values: {factor: 1},
			fields: [
				{
					type: 'range',
					name: 'factor',
					min: 1,
					max: 100,
					step: 1,
					caption: i18n('inputs.layer.factor'),
				},
			]
		});
		this.setContent(el);
	}

	destroy() {
		if (this._onComplete !== null) {
			this._onComplete(null);
			this._onComplete = null;
		}
		super.destroy();
	}
}
